import { MapperHomeContainer } from "../../../containers";
import React from "react";
import { Row, Col } from "react-bootstrap";
import { withAppLayout } from "../../../hoc";
import { LoaderWrapper } from "../../../components";
import MappingTemplateContainer from "../../../containers/Mapper/MappingTemplateContainer/MappingTemplateContainer";

export const MappingTemplate = (props) => {
  return (
    <LoaderWrapper className="row manage-company-wrapper">
      <Col className="h-100">
        <Row sm="12" className="h-100">
          <Col className="h-100 manage-menu-content">
            <MappingTemplateContainer {...props} />
          </Col>
        </Row>
      </Col>
    </LoaderWrapper>
  );
};

const ManageMappingTemplateWithProvider = (props) => {
  return <MappingTemplate {...props} />;
};

export default withAppLayout(ManageMappingTemplateWithProvider);
